export default __webpack_public_path__ + "static/media/dehli2.5b0af629.jpg";